import type { FaireProductEntity } from "../../entity_types/product";

export const p_hzkewsezcd: FaireProductEntity = {
  token: "p_hzkewsezcd",
  type: "product",
  name: "woodland animals assorted notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/4c8e00b0566cb1d7b5a5f699f121d8185fe292266a3116db4c2e54654b38f5c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d7a4a23803c9d8edc25d73309f9aa6ec2d387039c32050ab93f59aa85d368a05.jpeg",
  ],
  priceDollars: 8,
  description:
    'Send sweet greetings to your loved ones. The assorted set of woodland animal notecards are blank on the inside with charming watercolor illustrations of a bear, deer, fox, owl, hedgehog, moose, racoon, and chipmunk on the front. They bring a touch of whimsical beauty to your thank-you notes, birthday wishes, housewarming gifts, and more.\n\n𝗗𝗲𝘁𝗮𝗶𝗹𝘀:\n\n• set of eight folded cards + envelopes, one of each illustration\n• blank inside\n• 5.5" x 4.25"\n• Printed on 120lb superfine paper\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:13.153Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
